<ngx-spinner 
  bdColor = "rgba(0, 0, 0, 0.8)" 
  size = "medium" 
  color = "#fff" 
  type = "line-spin-clockwise-fade" 
  [fullScreen] = "true"
>
  <p style="color: white" > {{ 'LOADING' | translate }}... </p>
</ngx-spinner>
<div class="login-wrapper">

  <mat-card class="box">
    <img mat-card-image src="ARMUR_horizontal.png">
    <mat-card-header>
      <mat-card-title style="width: 300px; text-align: center;">Portal MVX</mat-card-title>
    </mat-card-header>

    <form class="example-form" [formGroup]="loginForm" (ngSubmit)="onSubmit()">
      <mat-card-content>
        <mat-form-field appearance="outline" class="example-full-width">
          <mat-label>{{ 'USER' | translate }}</mat-label>
          <input matInput formControlName="employeeNumber">
        </mat-form-field>

        <mat-form-field appearance="outline" class="example-full-width">
          <mat-label>{{ 'PASSWORD' | translate }}</mat-label>
          <input matInput [type]="hidePassword ? 'password' : 'text'" formControlName="password">
          <button mat-icon-button matSuffix (click)="hidePassword = !hidePassword" type="button">
            <mat-icon>{{ hidePassword ? 'visibility_off' : 'visibility' }}</mat-icon>
          </button>
        </mat-form-field>
      </mat-card-content>
      <button mat-stroked-button color="accent" class="btn-block">{{ 'LOGIN' | translate }}</button>
    </form>
  </mat-card>
</div>
